import { get, remove, set } from 'lib/storage/isomorphicSessionStorage'
import type { CreateGhaVoucherInput } from 'actions/MetasearchVoucherActions'

const PENDING_GHA_VOUCHER_SESSION_KEY = 'pendingGhaVoucher'

function isCompletePendingGhaVoucher(input: CreateGhaVoucherInput | undefined): input is CreateGhaVoucherInput {
  return !!(
    (input?.token || input?.rateRuleId) &&
    input.propertyId &&
    input.checkIn &&
    input.checkOut &&
    input.rooms?.length
  )
}

/**
 * Voucher inputs the offer page resolved but could not use yet, because a GHA voucher is
 * assigned to a customer as it is created and nobody is signed in until checkout.
 *
 * `token`, `rateRuleId` and the advertised price all come from the landing URL, which
 * `/checkout` does not carry.
 * Session storage rather than checkout state so it survives a mid-checkout refresh.
 */
export function setPendingGhaVoucher(input: CreateGhaVoucherInput) {
  set(PENDING_GHA_VOUCHER_SESSION_KEY, input)
}

export function getPendingGhaVoucher(): CreateGhaVoucherInput | undefined {
  const pendingVoucher = (get(PENDING_GHA_VOUCHER_SESSION_KEY) ?? undefined) as CreateGhaVoucherInput | undefined
  if (!isCompletePendingGhaVoucher(pendingVoucher)) {
    remove(PENDING_GHA_VOUCHER_SESSION_KEY)
    return undefined
  }
  return pendingVoucher
}

export function clearPendingGhaVoucher() {
  remove(PENDING_GHA_VOUCHER_SESSION_KEY)
}
